/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';

export default class LocationDelete extends Component {
  location = null;
  close = null;
  saveAndClose = null;

  @action
  delete() {
    this.location.set('status', NSWStatus.DELETED);
    this.saveAndClose();
  }
}
